import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { EstensaPrintService } from '../services/angularjs/estensa-print.service';
import { convertBase64ToUint8Array } from '../utils/utils';

type PdfModalComponentModal = 'version' | 'pdf' | 'none';

@Component({
    selector: 'se-pdf-modal',
    styleUrls: ['./pdf-modal.component.scss'],
    templateUrl: './pdf-modal.component.html',
})
export class PdfModalComponent implements OnChanges, OnDestroy {
    @ViewChild('documentModal')
    documentModal: TemplateRef<any>;

    @Input()
    visible = false;

    @Input()
    sourceBase64: string;

    @Input()
    print: boolean;

    @Output()
    busy = new EventEmitter<boolean>(true);

    @Output()
    visibleChange = new EventEmitter<boolean>(true);

    @Output()
    documentIdChange = new EventEmitter<string>();

    @Output()
    ecgDocIdArrayChange = new EventEmitter<string[]>();

    activeDialog: MatDialogRef<any>;

    activeDialogName: PdfModalComponentModal = 'none';

    afterCloseEventSubscription: Subscription;

    zoom = 1.2;

    source: Uint8Array;

    constructor(
        public dialog: MatDialog,
        private printService: EstensaPrintService,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.visible && !changes.visible.currentValue) {
            this.closeDialog();
        } else if (changes.visible && changes.visible.currentValue) {
            this.selectSource();
        }
    }

    ngOnDestroy() {
        this.afterCloseEventSubscription?.unsubscribe();
    }

    closeDialog() {
        if (this.activeDialog && this.activeDialog.getState() == MatDialogState.OPEN) {
            this.activeDialog.close();
        }
    }

    onPrint() {
        this.printService.print(convertBase64ToUint8Array(this.sourceBase64));
    }

    zoomIn() {
        this.zoom += 0.1;
    }

    zoomOut() {
        if (this.zoom > 0.1) {
            this.zoom -= 0.1;
        }
    }

    private selectSource() {
        if (!this.sourceBase64) {
            return;
        }

        this.source = convertBase64ToUint8Array(this.sourceBase64);

        if (this.print) {
            this.openPrintDialog();
        } else {
            this.openDialog();
        }
    }

    private openPrintDialog() {
        try {
            this.printService.print(this.source);
        } finally {
            this.source = null;
            this.visibleChange.emit(false);
            this.documentIdChange.emit('');
            this.ecgDocIdArrayChange.emit([]);
        }
    }

    private openDialog() {
        this.activeDialog = this.dialog.open(this.documentModal, {
            autoFocus: false,
        });

        this.afterCloseEventSubscription = this.activeDialog.afterClosed().subscribe(() => {
            this.source = null;
            this.visibleChange.emit(false);
            this.documentIdChange.emit('');
            this.ecgDocIdArrayChange.emit([]);

            this.afterCloseEventSubscription.unsubscribe();
        });
    }
}
